// TSS vite/03 §"Query keys convention".
//
// `tasks` and `events` as the first element, matching the resources these
// actually read: a second vocabulary for the same rows would make an
// invalidation from the task screens miss them.
export const reviewKeys = {
    all:      ['tasks'],
    waiting:  (params) => ['tasks', 'in-review', params],
    rounds:   (taskId) => ['tasks', 'detail', String(taskId), 'review-rounds'],
    progress: (taskId) => ['events', 'task', String(taskId), 'progress'],
};
